// MORE (UI rebuild batch 1): every screen the phone's tabs and the laptop's sidebar do not hold, in four
// sections — Daily work, Control, Reports, Administration (lib/routes.ts `v2.section`). Adjust balance is not here:
// the audit door is reached from the palette, a party's page and Treasury (operator ruling C1, 26 Oct 2026).
import { PageHead, Tile, TileGroup } from '../../components/v2/kit';
import { ENTRY_SECTIONS, MORE_SECTIONS, PHONE_TABS, entryRoutes, moreRoutes, navTitle } from '../../lib/routes';
import { PREVIEW_ON } from '../../lib/ui-v2';
import { Link } from 'react-router-dom';

export function MoreHub() {
  return (
    <>
      <PageHead title="More" />
      {/* With main's daily tabs (C4's `daily` answer) the phone has no New tab: the doors lead this page. */}
      {!PHONE_TABS.includes('/new') && (
        <TileGroup heading="New entry">
          {ENTRY_SECTIONS.flatMap((s) => entryRoutes(s)).map((r) => <Tile key={r.path} to={r.path} icon={r.icon} title={navTitle(r)} sub={r.v2?.sub} />)}
        </TileGroup>
      )}
      {MORE_SECTIONS.map((section) => {
        const rows = moreRoutes(section);
        if (rows.length === 0) return null;
        return (
          <TileGroup key={section} heading={section}>
            {rows.map((r) => <Tile key={r.path} to={r.path} icon={r.icon} title={navTitle(r)} sub={r.v2?.sub} />)}
          </TileGroup>
        );
      })}
      {/* The owner's preview (lib/ui-v2.ts): the way back on the phone, which has no sidebar. */}
      {PREVIEW_ON && <Link to="/ui-preview" className="btn-link text-meta">Today&apos;s console</Link>}
    </>
  );
}
